// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as $$String from "../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_list from "../../../../../../node_modules/rescript/lib/es6/js_list.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Js_string from "../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as UrlUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as Config$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as PathHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/PathHelpers.mjs";
import * as HomeHelper$PorterinFeature from "../../../containers/home/domain/helper/HomeHelper.mjs";
import * as CookieStore$PorterinFeature from "../../../containers/fare-estimate-v1/utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../containers/fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as PageviewConstants$PorterinFeature from "../constants/PageviewConstants.mjs";
import * as AnalyticsConstants$PorterinFeature from "../constants/AnalyticsConstants.mjs";

function getPillarPageName(url, index) {
  return Belt_Option.getWithDefault(Js_list.nth(PathHelpers$PorterinUtils.getRoutePathList(url), index), "");
}

function getRoutePathList(str) {
  return Belt_Option.getWithDefault(Belt_List.tail($$Array.to_list(Js_string.split("/", str))), /* [] */0);
}

function getNumberedEventLabel(labels) {
  var modified_labels = List.mapi((function (index, label) {
          return String(index + 1 | 0) + "_" + label;
        }), labels);
  return $$String.concat("#", modified_labels);
}

function getPillarOmsPageName(url, defaultValue) {
  var path = Js_string.split("?", url);
  var match = path.length;
  if (match !== 0) {
    return Caml_array.get(path, 0);
  } else {
    return defaultValue;
  }
}

function getCategoryName(router) {
  var match = getRoutePathList(router.pathname);
  if (!match) {
    return AnalyticsConstants$PorterinFeature.$$default;
  }
  switch (match.hd) {
    case "" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.home;
        }
    case "about-us" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.about_us;
        }
    case "bikes" :
        var match$1 = match.tl;
        if (match$1) {
          if (match$1.tl) {
            return AnalyticsConstants$PorterinFeature.$$default;
          } else {
            return AnalyticsConstants$PorterinFeature.v2_2w_city + Js_string.sliceToEnd(PageviewConstants$PorterinFeature.ga_path_bike_parcel_keyword_prefix.length, getPillarOmsPageName(router.asPath, ""));
          }
        } else {
          return AnalyticsConstants$PorterinFeature.bikes_pillar;
        }
    case "careers" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.careers;
        }
    case "city" :
        var match$2 = match.tl;
        if (match$2 && !match$2.tl) {
          return AnalyticsConstants$PorterinFeature.city + Js_string.sliceToEnd(PageviewConstants$PorterinFeature.ga_path_city_page_prefix.length, getPillarOmsPageName(router.asPath, ""));
        } else {
          return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "cookie-policy" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.cookie_policy;
        }
    case "courier" :
        var match$3 = match.tl;
        if (match$3) {
          if (match$3.hd === "tnc") {
            if (match$3.tl) {
              return AnalyticsConstants$PorterinFeature.$$default;
            } else {
              return AnalyticsConstants$PorterinFeature.courier_tnc;
            }
          } else if (match$3.tl) {
            return AnalyticsConstants$PorterinFeature.$$default;
          } else {
            return AnalyticsConstants$PorterinFeature.courier_city + getPillarOmsPageName(getPillarPageName(router.asPath, 1), "");
          }
        } else {
          return AnalyticsConstants$PorterinFeature.courier;
        }
    case "enterprise" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.enterprise;
        }
    case "enterprise-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.enterprise_faq;
        }
    case "fare_estimate_mob" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.fare_estimate_mob;
        }
    case "governance" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.governance;
        }
    case "insurance-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.insurance_faq;
        }
    case "offers" :
        var match$4 = match.tl;
        if (!match$4) {
          return AnalyticsConstants$PorterinFeature.offers;
        }
        switch (match$4.hd) {
          case "cashback" :
              var match$5 = match$4.tl;
              if (match$5 && !match$5.tl) {
                return AnalyticsConstants$PorterinFeature.offers_cashback;
              } else {
                return AnalyticsConstants$PorterinFeature.$$default;
              }
          case "discount" :
              var match$6 = match$4.tl;
              if (match$6 && !match$6.tl) {
                return AnalyticsConstants$PorterinFeature.offers_discount;
              } else {
                return AnalyticsConstants$PorterinFeature.$$default;
              }
          default:
            return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "partners" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.partners;
        }
    case "porter-wallet-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.porter_wallet_faq;
        }
    case "privacy-policy" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.privacy_policy;
        }
    case "privacy-policy-v1" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.privacy_policy_v1;
        }
    case "privacy-policy-v2" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.privacy_policy_v2;
        }
    case "referral-tnc" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.referral_tnc;
        }
    case "services" :
        var match$7 = match.tl;
        if (!match$7) {
          return AnalyticsConstants$PorterinFeature.services_pillar;
        }
        if (!match$7.tl) {
          return AnalyticsConstants$PorterinFeature.services_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 1), AnalyticsConstants$PorterinFeature.$$default);
        }
        switch (match$7.hd) {
          case "courier" :
              if (match$7.tl.tl) {
                return AnalyticsConstants$PorterinFeature.$$default;
              } else {
                return AnalyticsConstants$PorterinFeature.services_courier_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 2), AnalyticsConstants$PorterinFeature.$$default);
              }
          case "trucks" :
              if (match$7.tl.tl) {
                return AnalyticsConstants$PorterinFeature.$$default;
              } else {
                return AnalyticsConstants$PorterinFeature.services_trucks_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 2), AnalyticsConstants$PorterinFeature.$$default);
              }
          case "two-wheelers" :
              if (match$7.tl.tl) {
                return AnalyticsConstants$PorterinFeature.$$default;
              } else {
                return AnalyticsConstants$PorterinFeature.services_2w_keyword + getPillarOmsPageName(getPillarPageName(router.asPath, 2), AnalyticsConstants$PorterinFeature.$$default);
              }
          default:
            return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "spot-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.spot_faq;
        }
    case "support" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return AnalyticsConstants$PorterinFeature.support;
        }
    case "terms-of-service" :
        var match$8 = match.tl;
        if (match$8) {
          if (match$8.hd === "partners" && !match$8.tl) {
            return AnalyticsConstants$PorterinFeature.terms_of_service_partners;
          } else {
            return AnalyticsConstants$PorterinFeature.$$default;
          }
        } else {
          return AnalyticsConstants$PorterinFeature.terms_of_service;
        }
    case "trucks" :
        var match$9 = match.tl;
        if (!match$9) {
          return AnalyticsConstants$PorterinFeature.trucks_pillar;
        }
        var match$10 = match$9.tl;
        if (match$10) {
          if (match$10.tl) {
            return AnalyticsConstants$PorterinFeature.$$default;
          } else {
            return AnalyticsConstants$PorterinFeature.trucks_inventory + Js_string.sliceToEnd(PageviewConstants$PorterinFeature.ga_path_trucks_inventory_prefix.length, getPillarOmsPageName(router.asPath, "")) + " " + getPillarOmsPageName(getPillarPageName(router.asPath, 2), AnalyticsConstants$PorterinFeature.$$default);
          }
        } else {
          return AnalyticsConstants$PorterinFeature.trucks_city + Js_string.sliceToEnd(PageviewConstants$PorterinFeature.ga_path_trucks_prefix.length, getPillarOmsPageName(router.asPath, ""));
        }
    default:
      return AnalyticsConstants$PorterinFeature.$$default;
  }
}

function getUtmString(param) {
  var url = window.location.href;
  var urlParams = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(url));
  var utm_source = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "utm_source"), "", (function (x) {
          return x;
        }));
  var utm_campaign = Belt_Option.mapWithDefault(Js_dict.get(urlParams, "utm_campaign"), "", (function (x) {
          return x;
        }));
  return [
          utm_source,
          utm_campaign
        ];
}

function getPageName(pathname) {
  var match = getRoutePathList(pathname);
  if (!match) {
    return AnalyticsConstants$PorterinFeature.$$default;
  }
  switch (match.hd) {
    case "" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "home";
        }
    case "about-us" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "about_us";
        }
    case "bike-parcel" :
        var match$1 = match.tl;
        if (match$1 && !match$1.tl) {
          return "2w";
        } else {
          return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "careers" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "careers";
        }
    case "city" :
        var match$2 = match.tl;
        if (match$2 && !match$2.tl) {
          return "city";
        } else {
          return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "courier" :
        var match$3 = match.tl;
        if (match$3) {
          if (match$3.hd === "tnc") {
            if (match$3.tl) {
              return AnalyticsConstants$PorterinFeature.$$default;
            } else {
              return "courier_tnc";
            }
          } else if (match$3.tl) {
            return AnalyticsConstants$PorterinFeature.$$default;
          } else {
            return "courier";
          }
        } else {
          return "courier";
        }
    case "enterprise" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "enterprise";
        }
    case "enterprise-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "enterprise_faq";
        }
    case "enterprise-lead-page" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "enterprise_lead_page";
        }
    case "fare-estimate" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "fare_estimate_v2";
        }
    case "fare_estimate_mob" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "fare_estimate_mob";
        }
    case "governance" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "governance";
        }
    case "insurance-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "insurance_faq";
        }
    case "offers" :
        var match$4 = match.tl;
        if (!match$4) {
          return "offers";
        }
        switch (match$4.hd) {
          case "cashback" :
              var match$5 = match$4.tl;
              if (match$5 && !match$5.tl) {
                return "cashback";
              } else {
                return AnalyticsConstants$PorterinFeature.$$default;
              }
          case "discount" :
              var match$6 = match$4.tl;
              if (match$6 && !match$6.tl) {
                return "discount";
              } else {
                return AnalyticsConstants$PorterinFeature.$$default;
              }
          default:
            return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "order-history" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "order_history";
        }
    case "order-review" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "order_review";
        }
    case "packers-and-movers" :
        var match$7 = match.tl;
        if (!match$7) {
          return AnalyticsConstants$PorterinFeature.$$default;
        }
        if (match$7.hd === "safety-guarantee" && !match$7.tl) {
          return "pnm_safety_guarantee";
        }
        var match$8 = match$7.tl;
        if (match$8) {
          if (match$8.tl) {
            return AnalyticsConstants$PorterinFeature.$$default;
          } else {
            return "pnm_hyperlocal";
          }
        } else {
          return "pnm_city";
        }
        break;
    case "partners" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "partners";
        }
    case "porter-wallet-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "porter_wallet_faq";
        }
    case "privacy-policy" :
    case "privacy-policy-v1" :
    case "privacy-policy-v2" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "privacy_policy";
        }
    case "referral-tnc" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "refferal_tnc";
        }
    case "services" :
        var match$9 = match.tl;
        if (!match$9) {
          return "seo_page";
        }
        if (!match$9.tl) {
          return "seo_page";
        }
        switch (match$9.hd) {
          case "courier" :
              if (match$9.tl.tl) {
                return AnalyticsConstants$PorterinFeature.$$default;
              } else {
                return "courier_seo_page";
              }
          case "trucks" :
              if (match$9.tl.tl) {
                return AnalyticsConstants$PorterinFeature.$$default;
              } else {
                return "trucks_seo_page";
              }
          case "two-wheelers" :
              if (match$9.tl.tl) {
                return AnalyticsConstants$PorterinFeature.$$default;
              } else {
                return "2w_seo_page";
              }
          default:
            return AnalyticsConstants$PorterinFeature.$$default;
        }
    case "spot-faq" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "spot_faq";
        }
    case "support" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "support";
        }
    case "terms-of-service" :
        var match$10 = match.tl;
        if (match$10) {
          if (match$10.hd === "partners" && !match$10.tl) {
            return "tos_partners";
          } else {
            return AnalyticsConstants$PorterinFeature.$$default;
          }
        } else {
          return "terms_of_service";
        }
    case "tools" :
        var match$11 = match.tl;
        if (match$11 && match$11.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "utility_tools";
        }
    case "track-order" :
        if (match.tl) {
          return AnalyticsConstants$PorterinFeature.$$default;
        } else {
          return "track_order";
        }
    case "trucks" :
        var match$12 = match.tl;
        if (!match$12) {
          return AnalyticsConstants$PorterinFeature.$$default;
        }
        var match$13 = match$12.tl;
        if (match$13) {
          if (match$13.tl) {
            return AnalyticsConstants$PorterinFeature.$$default;
          } else {
            return "trucks_inventory";
          }
        } else {
          return "trucks";
        }
    case "two-wheelers" :
        var match$14 = match.tl;
        if (match$14 && !match$14.tl) {
          return "2w";
        } else {
          return AnalyticsConstants$PorterinFeature.$$default;
        }
    default:
      return AnalyticsConstants$PorterinFeature.$$default;
  }
}

function desktopLocationAccuracyUserProperty(param) {
  var visitorId = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.visitorId);
  if (Config$PorterinUtils.desktop_location_accuracy_rollout_pct !== undefined && Config$PorterinUtils.desktop_location_accuracy_rollout_pct > 0 && visitorId.length > 0 && HomeHelper$PorterinFeature.getIsContainsVisitorId(Config$PorterinUtils.desktop_location_accuracy_rollout_pct)) {
    return "tg";
  } else {
    return "cg";
  }
}

function userLoginStatus(param) {
  var auth_token = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.auth_token);
  var mobile = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.mobile);
  if (auth_token.length > 0 && mobile.length > 0) {
    return "loggedin";
  } else {
    return "loggedout";
  }
}

function getGlobalAttributes(param) {
  return {
          backend_service: "platform",
          user_properties: {
            website_service: "platform",
            location_accuracy_desktop: desktopLocationAccuracyUserProperty(undefined),
            login_status: userLoginStatus(undefined)
          }
        };
}

function getMoEngageConfigByLocale(locale) {
  var countryKey = locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD ? "bd" : (
      locale === LocaleConstants$PorterinUtils.en_AE ? "ae" : (
          locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.tr_TR ? "tr" : (
              locale === LocaleConstants$PorterinUtils.en_IN ? "in" : ""
            )
        )
    );
  var moengageCountryConfig = Js_dict.get(Config$PorterinUtils.moengage_config, countryKey);
  if (moengageCountryConfig !== undefined && moengageCountryConfig.moengage_app_id.trim() !== "") {
    return moengageCountryConfig;
  }
  
}

export {
  getPillarPageName ,
  getRoutePathList ,
  getNumberedEventLabel ,
  getPillarOmsPageName ,
  getCategoryName ,
  getUtmString ,
  getPageName ,
  desktopLocationAccuracyUserProperty ,
  userLoginStatus ,
  getGlobalAttributes ,
  getMoEngageConfigByLocale ,
}
/* Config-PorterinUtils Not a pure module */
